import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import useCampaignSearch from '~pages/CampaignManagement/CampaignList/useCampaignSearch';
import { getCampaigns } from '~pages/CampaignManagement/CampaignList/useCampaignSearch/api';
import { CampaignListItem } from '~pages/CampaignManagement/domain';

import BaseNode from '../BaseNode';
import { ContactFlowNodeProps } from '..';

export default function FetchLeadNode(props: ContactFlowNodeProps) {
  const { campaigns = [], defaultCampaign } = props.data.parameter.fetchLead ?? {};
  const form = useForm<{
    campaigns: CampaignListItem[];
    defaultCampaign: CampaignListItem;
  }>();
  useEffect(() => {
    (async () => {
      const campaignIds = [...campaigns];
      if (defaultCampaign) {
        campaignIds.push(defaultCampaign);
      }
      if (campaignIds.length > 0) {
        const res = await getCampaigns({
          campaignIds,
        });
        form.reset({
          campaigns: res?.campaigns.filter((v) => campaigns.some((i) => i === v.id)),
          defaultCampaign: res?.campaigns.find((v) => v.id === defaultCampaign),
        });
      }
    })();
  }, []);
  return (
    <BaseNode
      {...props}
      title='Fetch Lead'
      parameterForm={form}
      renderParameterForm={(fetchLead) => {
        const { campaigns, defaultCampaign } = fetchLead ?? {};
        return (
          <>
            <Typography>
              Campaigns: {JSON.stringify(campaigns?.map((v) => `${v?.name || '--'} #${v?.id ?? '--'}`))}
            </Typography>
            <Typography>
              Default Campaign: {defaultCampaign?.name || '--'} #{defaultCampaign?.id ?? '--'}
            </Typography>
          </>
        );
      }}
      transformParameter={({ campaigns, defaultCampaign }) => ({
        fetchLead: {
          campaigns: campaigns.map((v) => v.id),
          defaultCampaign: defaultCampaign.id,
        },
      })}
      renderEditParameter={({ control }, { isEdit }) => {
        const [search, setSearch] = useState<string>('');
        const { list, loading } = useCampaignSearch(search, {
          shouldFetch: isEdit,
        });
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}>
            <Controller
              control={control}
              name='campaigns'
              render={({ field: { onChange, value, ...rest } }) => (
                <Autocomplete
                  {...rest}
                  multiple
                  fullWidth
                  filterSelectedOptions
                  options={list}
                  loading={loading}
                  loadingText='Fetching campaigns...'
                  onInputChange={(_, v) => setSearch(v)}
                  renderInput={(params) => <TextField {...params} label='Campaigns' />}
                  getOptionLabel={(v) => `${v.name} #${v.id}`}
                  isOptionEqualToValue={(o, v) => o.id === v.id}
                  onChange={(e, v) => onChange(v)}
                  value={value || null}
                />
              )}
            />
            <Controller
              control={control}
              name='defaultCampaign'
              render={({ field: { onChange, value, ...rest } }) => (
                <Autocomplete
                  {...rest}
                  fullWidth
                  filterSelectedOptions
                  options={list}
                  loading={loading}
                  loadingText='Fetching campaigns...'
                  onInputChange={(_, v) => setSearch(v)}
                  renderInput={(params) => <TextField {...params} label='Default Campaign' />}
                  getOptionLabel={(v) => `${v.name} #${v.id}`}
                  isOptionEqualToValue={(o, v) => o.id === v.id}
                  onChange={(e, v) => onChange(v)}
                  value={value || null}
                />
              )}
            />
          </Box>
        );
      }}
    />
  );
}
